export default "__VITE_ASSET__u5JmEM_X__"